import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface CategoryTranslation {
  label_en: string | null;
  label_lv: string | null;
  label_ru: string | null;
}

export function useCategoryTranslations() {
  const [translations, setTranslations] = useState<Record<string, CategoryTranslation>>({});

  useEffect(() => {
    const fetchTranslations = async () => {
      try {
        const { data } = await (supabase as any)
          .from('menu_category_translations')
          .select('*');
        if (data) {
          const map: Record<string, CategoryTranslation> = {};
          data.forEach((row: any) => {
            map[row.category] = {
              label_en: row.label_en,
              label_lv: row.label_lv,
              label_ru: row.label_ru,
            };
          });
          setTranslations(map);
        }
      } catch (err) {
        console.error('Error fetching category translations:', err);
      }
    };
    fetchTranslations();
  }, []);

  const translateCategory = (category: string, language: 'en' | 'lv' | 'ru'): string => {
    const t = translations[category];
    if (!t) return category;
    if (language === 'lv' && t.label_lv) return t.label_lv;
    if (language === 'ru' && t.label_ru) return t.label_ru;
    if (language === 'en' && t.label_en) return t.label_en;
    return category;
  };

  return { categoryTranslations: translations, translateCategory };
}
